import * as THREE from 'three';
export const createTextSprite = (text, options = {}) => {
  const { fontSize = 48, color = '#ffffff', strokeColor = '#000000', padding = 8 } = options;
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  function drawText(newText) {
    // Measure using current context
    ctx.font = `${fontSize}px Arial`;
    const textWidth = ctx.measureText(newText).width;

    // Resize canvas to fit text. Resizing resets the drawing buffer and
    // context state — re-acquire the 2D context after resizing.
    canvas.width = Math.max(1, Math.ceil(textWidth + padding * 2));
    canvas.height = Math.max(1, Math.ceil(fontSize + padding * 2));

    const ctx2 = canvas.getContext('2d');
    ctx2.font = `${fontSize}px Arial`;
    ctx2.textBaseline = 'top';
    ctx2.clearRect(0, 0, canvas.width, canvas.height);
    ctx2.strokeStyle = strokeColor;
    ctx2.lineWidth = 4;
    // Draw using top-left baseline with padding
    const y = padding / 2;
    ctx2.strokeText(newText, padding, y + (fontSize - (fontSize * 0.8)) );
    ctx2.fillStyle = color;
    ctx2.fillText(newText, padding, y + (fontSize - (fontSize * 0.8)) );
  }

  drawText(text);

  const texture = new THREE.CanvasTexture(canvas);
  const material = new THREE.SpriteMaterial({ map: texture, transparent: true });
  const sprite = new THREE.Sprite(material);
  sprite.scale.set(canvas.width / 10, canvas.height / 10, 1);

  // 🔑 updateTextSprite ve DXF export için gerekli bilgiler
  sprite.userData = {
    type: 'text', // DXF export için entity tipi
    drawText,
    texture,
    canvas,
    text,
    fontSize: fontSize / 10 // Scale'e göre ayarlanmış fontSize (DXF için)
  };

  return sprite;
};
